/**
 * 启动倒计时
 * @param {number} minutes 初始分钟数（整数）
 * @param {object} options 可选的选择器配置
 */
function startCountdownTimer(minutes = 5, options = {}) {
    const selector = {
      minuteLeft: '.minutes',
      minuteRight: '.minutes_two',
      secondLeft: '.seconds',
      secondRight: '.seconds_two',
      ...options
    };
  
    let m = minutes - 1;
    let s = 59;
  
    const updateUI = (m, s) => {
      const mStr = m < 10 ? '0' + m : String(m);
      const sStr = s < 10 ? '0' + s : String(s);
  
      $(selector.minuteLeft).text(mStr[0]);
      $(selector.minuteRight).text(mStr[1]);
      $(selector.secondLeft).text(sStr[0]);
      $(selector.secondRight).text(sStr[1]);
    };
  
    updateUI(m, s);
  
    const timer = setInterval(() => {
      if (m <= 0 && s <= 0) {
        clearInterval(timer);
        console.log('倒计时结束');
        return;
      }
  
      updateUI(m, s);
      s--;
  
      if (s < 0) {
        s = 59;
        m--;
      }
    }, 1000);
  
    return timer; // 可用于手动 clearInterval(timer)
}
  